import { render, staticRenderFns } from "./home_discover.vue?vue&type=template&id=f3be1360&scoped=true"
import script from "./home_discover.vue?vue&type=script&lang=js"
export * from "./home_discover.vue?vue&type=script&lang=js"
import style0 from "./home_discover.vue?vue&type=style&index=0&id=f3be1360&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3be1360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3be1360')) {
      api.createRecord('f3be1360', component.options)
    } else {
      api.reload('f3be1360', component.options)
    }
    module.hot.accept("./home_discover.vue?vue&type=template&id=f3be1360&scoped=true", function () {
      api.rerender('f3be1360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_discover.vue"
export default component.exports